import Paginator from "../components/ui/Paginator";

export const pagination = {
    components: { Paginator },
    data() {
        return {
            pagination: {
                per_page: 25,
                current_page: 1,
                last_page: 1,
            },
            page: 1,
        };
    },
    methods: {
        setPage(page) {
            this.pagination.current_page = page;
        },
    },
};
